<template>
  <div>
    <div class="rf-cabecera">
      <span class="rf-eyebrow">Proyectos en todo Chile</span>
      <h1 class="rf-titulo-sans">Selecciona la Región</h1>
      <p v-if="sitio.regiones_texto" class="rf-bajada">{{ sitio.regiones_texto }}</p>
    </div>

    <div class="rf-mapas">
      <div class="rf-panel rf-panel--globo">
        <p class="rf-panel-titulo">Chile en el hemisferio sur</p>
        <svg :viewBox="`0 0 ${GLOBO.tamano} ${GLOBO.tamano}`" role="img" aria-label="Chile en Sudamérica">
          <circle
            :cx="GLOBO.radio + 10"
            :cy="GLOBO.radio + 10"
            :r="GLOBO.radio"
            fill="none"
            stroke="#b8c8c0"
            stroke-width="0.8"
          />
          <path
            v-for="(d, i) in GLOBO.graticula"
            :key="`g${i}`"
            :d="d"
            fill="none"
            stroke="#c9d6cf"
            stroke-width="0.6"
            stroke-dasharray="3 3"
          />
          <path
            v-for="p in GLOBO.paises"
            :key="p.id"
            :d="p.d"
            :fill="p.chile ? '#0B4C48' : '#c3d3cb'"
            stroke="#ffffff"
            stroke-width="0.4"
          />
          <line
            :x1="GLOBO.chile[0] - 34"
            :y1="GLOBO.chile[1]"
            :x2="GLOBO.chile[0]"
            :y2="GLOBO.chile[1]"
            stroke="#07394f"
            stroke-width="0.6"
          />
          <text class="rf-svg-texto" :x="GLOBO.chile[0] - 37" :y="GLOBO.chile[1] + 3" text-anchor="end">CHILE</text>
          <line
            :x1="GLOBO.argentina[0]"
            :y1="GLOBO.argentina[1]"
            :x2="GLOBO.argentina[0] + 34"
            :y2="GLOBO.argentina[1]"
            stroke="#07394f"
            stroke-width="0.6"
          />
          <circle :cx="GLOBO.argentina[0]" :cy="GLOBO.argentina[1]" r="1.4" fill="#07394f" />
          <text class="rf-svg-texto" :x="GLOBO.argentina[0] + 37" :y="GLOBO.argentina[1] + 3">ARGENTINA</text>
        </svg>
      </div>

      <div class="rf-panel">
        <p class="rf-panel-titulo">Regiones de Chile</p>
        <svg :viewBox="`0 0 ${CHILE.ancho} ${CHILE.alto}`" role="group" aria-label="Mapa de las regiones de Chile">
          <g
            v-for="r in regiones"
            :key="r.codigo"
            class="rf-region"
            :class="{ 'rf-region--con': r.proyectos > 0 }"
            role="link"
            tabindex="0"
            :aria-label="`${r.nombre}: ${cuenta(r.proyectos)}`"
            @click="ir(r)"
            @keydown.enter="ir(r)"
          >
            <title>{{ r.nombre }} · {{ cuenta(r.proyectos) }}</title>
            <path :d="r.d" />
            <line :x1="r.ancla[0]" :y1="r.ancla[1]" :x2="CHILE.xEtiqueta - 5" :y2="r.y + 5.5" />
            <circle :cx="r.ancla[0]" :cy="r.ancla[1]" r="1.4" />
            <text class="rf-svg-texto" :x="CHILE.xEtiqueta" :y="r.y + 9">
              <tspan v-for="(linea, i) in r.etiqueta" :key="i" :x="CHILE.xEtiqueta" :dy="i ? 12 : 0">{{ linea }}</tspan>
            </text>
            <text
              v-if="r.proyectos"
              class="rf-svg-cuenta"
              :x="CHILE.xEtiqueta"
              :y="r.y + 9 + r.etiqueta.length * 12"
            >{{ cuenta(r.proyectos) }}</text>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { CHILE, GLOBO } from './mapas';

export default {
  name: 'RfRegiones',
  props: {
    sitio: { type: Object, required: true },
  },
  data() {
    return { CHILE, GLOBO };
  },
  computed: {
    // El mapa dibuja por código oficial; la base entrega id y nombre por región.
    regiones() {
      const porCodigo = {};
      this.sitio.regiones.forEach((r) => { if (r.codigo) porCodigo[r.codigo] = r; });
      return CHILE.regiones
        .filter((r) => porCodigo[r.codigo])
        .map((r) => ({ ...r, ...porCodigo[r.codigo] }));
    },
  },
  methods: {
    cuenta(n) {
      if (!n) return 'sin proyectos';
      return n === 1 ? '1 proyecto' : `${n} proyectos`;
    },
    ir(region) {
      window.location.assign(`/landing-refugios/region/${region.id}`);
    },
  },
};
</script>
